import React, { useState } from 'react';
import { connect } from 'react-redux';
import FiltroListIpb from './components/FiltroListIpb';
import Grid from '@mui/material/Grid';
import { useTransactionFailed } from './hooks/useTransactionFailed';
import { failedTransactionsListIpbAction } from '_models/redux/failed_transactions_ipb_list/action';
import { cleanFailedTransactionsListClean } from '_models/redux/failed_transactions_ipb_list/clean-action';
import { failedTransactionsDetailListIpbAction } from '_models/redux/failed_transactions_ipb_list_details/action';
import { cleanFailedTransactionsListIpbAction } from '_models/redux/failed_transactions_ipb_list_details/clean-action';
import { RenderLoader, RenderTable, RenderNoRecords } from './helpers';
import { cleanIccUnlocking } from '_models/redux/post-icc-unlocking/clean';
import { actionIccUnlockingAction } from '_models/redux/post-icc-unlocking/action';
import { useUnlockIcc } from './hooks/useUnlockIcc';
import { useSearchAndPagination } from './hooks/useSearchAndPagination';
import {
  detailDialogButtons,
  successDialogButtons,
  errorDialogButtons,
} from './helpers/dialogButtons';
import DialogsFailedTransactions from './components/DialogsFailedTransactions';

const PageFailedTransactionsIpb = ({
  failedTransactionsListIpbAction,
  failedTransactionsListIpb,
  cleanFailedTransactionsListClean,
  failedTransactionsDetailListIpbAction,
  failedTransactionsListDetailsIpb,
  cleanFailedTransactionsListIpbAction,
  transactionId,
  onClose,
  cleanIccUnlocking,
  actionIccUnlockingAction,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    isDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    getBackgroundColor,
    handleOpenPopUp,
  } = useTransactionFailed({
    failedTransactionsListIpbAction,
    failedTransactionsListIpb,
    cleanFailedTransactionsListClean,
    failedTransactionsDetailListIpbAction,
    failedTransactionsListDetailsIpb,
    cleanFailedTransactionsListIpbAction,
    transactionId,
    onClose,
    cleanIccUnlocking,
    actionIccUnlockingAction,
  });

  // Nuevo estado para guardar los últimos filtros usados
  const [lastFilters, setLastFilters] = useState(null);

  // Modifica onSubmitWithFlag para guardar los filtros
  const { hasSearched, onSubmitWithFlag } = useSearchAndPagination((data) => {
    setLastFilters(data);
    onSubmit(data);
  });

  const refreshTable = () => {
    if (lastFilters) {
      onSubmit(lastFilters);
    }
  };

  const {
    isUnlockIccDialogOpen,
    unlockIccMessage,
    isSuccessDialogOpen,
    handleUnlockIcc,
    handleOpenUnlockIccDialog,
    handleCloseUnlockIccDialog,
    handleCloseSuccessDialog,
  } = useUnlockIcc({
    failedTransactionsListDetailsIpb,
    actionIccUnlockingAction,
    onSuccessClose: refreshTable,
  });

  return (
    <>
      <Grid>
        <h4>Transacciones fallidas IPB </h4>
      </Grid>
      <Grid marginBottom={4}>
        <FiltroListIpb
          onSubmit={onSubmitWithFlag}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Grid>
      <Grid>
        {loading ? (
          <RenderLoader />
        ) : mappedRows?.length > 0 ? (
          <RenderTable
            mappedRows={mappedRows}
            Columns={Columns}
            handleRowClick={handleRowClick}
            page={page}
            size={size}
            pagination={pagination}
            getBackgroundColor={getBackgroundColor}
            loading={loading}
          />
        ) : (
          hasSearched && <RenderNoRecords />
        )}
      </Grid>
      <DialogsFailedTransactions
        failedTransactionsListDetailsIpb={failedTransactionsListDetailsIpb}
        isDialogOpenDetails={isDialogOpenDetails}
        handleOpenPopUp={handleOpenPopUp}
        handleClose={handleClose}
        detailDialogButtons={detailDialogButtons(handleClose, handleOpenUnlockIccDialog)}
        isUnlockIccDialogOpen={isUnlockIccDialogOpen}
        handleCloseUnlockIccDialog={handleCloseUnlockIccDialog}
        handleUnlockIcc={handleUnlockIcc}
        unlockIccMessage={unlockIccMessage}
        isSuccessDialogOpen={isSuccessDialogOpen}
        handleCloseSuccessDialog={handleCloseSuccessDialog}
        successDialogButtons={successDialogButtons(handleCloseSuccessDialog)}
        isDialogOpen={isDialogOpen}
        dialogMessage={dialogMessage}
        errorDialogButtons={errorDialogButtons(handleClose)}
        errorMessage={errorMessage}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  failedTransactionsListIpb: state?.failedTransactionsListIpb,
  failedTransactionsListDetailsIpb: state?.failedTransactionsListDetailsIpb,
  iccUnlocking: state?.iccUnlocking,
});

const mapDispatchToProps = {
  failedTransactionsListIpbAction,
  cleanFailedTransactionsListClean,
  failedTransactionsDetailListIpbAction,
  cleanFailedTransactionsListIpbAction,
  cleanIccUnlocking,
  actionIccUnlockingAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageFailedTransactionsIpb);
